import { forwardRef, ReactNode, useId } from 'react';
import { ChangeHandler } from 'react-hook-form';
import Label from './Label';
import Error, { type ErrorMessage } from './Error';
import clsx from 'clsx';

export interface RadioInputFieldProps {
  label: ReactNode;
  description?: string;
  name: string;
  id?: string;
  additionalContainerClasses?: string;
  error?: ErrorMessage;
  onChange?: ChangeHandler;
  onBlur?: ChangeHandler;
  value: string;
  defaultChecked?: boolean;
}

export const RadioInputField = forwardRef<HTMLInputElement, RadioInputFieldProps>(
  function InternalCheckboxInputField(
    {
      label,
      name,
      id,
      additionalContainerClasses,
      onChange,
      onBlur,
      error,
      value,
      description,
      defaultChecked,
    },
    ref
  ) {
    const defaultId = useId();
    id = id ?? defaultId;
    return (
      <div id={id} className={clsx('  flex flex-col w-min', additionalContainerClasses)}>
        <div className="flex relative items-center">
          <div className="relative h-5">
            <input
              type="radio"
              onChange={onChange}
              onBlur={onBlur}
              ref={ref}
              id={`${id}::input`}
              name={name}
              value={value}
              defaultChecked={defaultChecked}
              className="relative w-5 h-5 rounded-full border appearance-none cursor-pointer peer shrink-0 dark:border-grey-600 border-grey-500 checked:bg-blue-600 checked:dark:bg-blue-600 hover:ring hover:dark:ring-blue-500 focus:ring focus:dark:ring-blue-500 focus:border-blue-500 dark:focus:border-blue-300 focus:outline-none"
            />
            <div className="peer-checked:block absolute hidden w-2 h-2 z-10 bg-white rounded-full top-1/2 left-1/2 -translate-y-1/2 -translate-x-1/2 pointer-events-none" />
          </div>

          <Label
            htmlFor={`${id}::input`}
            description={description}
            additionalClasses="ml-2 mt-0 font-bold "
          >
            {label}
          </Label>
        </div>
        <Error error={error} />
      </div>
    );
  }
);
